import { atom } from "recoil";
import { keysOfRecoil } from "store/recoil/keys";

export const appVersionState = atom<string>({
  key: keysOfRecoil.native.appVersion,
  default: "",
});
